import VTextarea from './VTextarea';
export { VTextarea };
export default VTextarea;
//# sourceMappingURL=index.js.map